import ErrorEntities from '@/models/error-entities'

import { AuthMutationTypes } from '@/store/modules/auth/AuthMutationTypes'

export interface State {
  errors: ErrorEntities
  pending: boolean
}

const initialState: State = {
  errors: {},
  pending: false,
}

export default {
  state: initialState,
  getters: {
    getForgotPasswordPageError(state: State): ErrorEntities {
      return state.errors
    },
    getForgotPasswordPagePending(state: State): boolean {
      return state.pending
    },
  },
  mutations: {
    [AuthMutationTypes.ForgotPassword](state: State) {
      state.pending = true
      state.errors = {}
    },
    [AuthMutationTypes.ForgotPasswordSuccess](state: State) {
      state.pending = false
      state.errors = {}
    },
    [AuthMutationTypes.ForgotPasswordFailure](state: State) {
      state.pending = false
    },
  },
}
